<template>
  <div
    style="height: 100%;width: 100%;max-width: 1600px;max-height: 900px;min-width: 1200px;min-height: 800px;display: flex;padding: 15px;border-radius: 15px;border: 1px solid #e4e7ed;box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);">
    <!-- 左边菜单 -->
    <div style="height: 100%;width: 77px;border-radius: 10px;background-color: #f8fafc;padding: calc(38.5px / 2);display: flex;flex-direction: column;justify-content: space-between;">
      <div style="border: 1px solid #020617;height: 38.5px;width: 38.5px;border-radius: 10px;">
        <Image :src="require('@/assets/38.png')" width="36" />
      </div>
      <Menu :model="items" style="width: 100%;min-width: 38.5px;margin-top: 15px;">
        <template #item="{ item }">
          <div v-tooltip="{value:item.tag,showDelay: 1000}" class="Menu-item" :class="{ 'Menu-item-active': MenuIsActive(item) }" @click="MenuClick(item)">
            <span :class="item.icon" />
          </div>
        </template>
      </Menu>
      
      <div v-tooltip="{value:'退出登录',showDelay: 1000}" class="Menu-item" style="margin-top: auto;">
        <span class="pi pi-sign-out" />
      </div>
    </div>
    <!-- 右边内容 -->
    <div style="height: 100%;width: calc(100% - 77px);padding-left: 15px;">
      <!-- 二级路径 -->
      <router-view />
    </div>
  </div>
</template>

<script>
import Menu from 'primevue/menu';
import Image from 'primevue/image';

export default {
  name: 'home',
  data() { 
    return {
      items: [
        { label: 'index1', icon: 'pi pi-home', to: '/home/index' ,tag:'主页'},
        { label: 'index2', icon: 'pi pi-cart-plus', to: '/home/buyData' ,tag:'购买数据'},
        { label: 'index3', icon: 'pi pi-qrcode', to: '/home/accountTool' ,tag:'账号工具'},
        { label: 'index4', icon: 'pi pi-link', to: '/home/onlineTool' ,tag:'在线工具'},
        { label: 'index5', icon: 'pi pi-user', to: '/home/personalCenter' ,tag:'个人中心'},
        { label: 'index6', icon: 'pi pi-database', to: '/home/needData' ,tag:'数据发布与需求'},
        { label: 'index7', icon: 'pi pi-telegram', to: 'contactService' ,tag:'联系客服'},
      ]
    }
  },
  components: {
    Menu,
    Image
  },
  methods: {
    MenuIsActive(item) {
      return this.$route.path === item.to;
    },
    MenuClick(item) {
      console.log(item);
      if (item.to != 'contactService') {
        this.$router.push(item.to);
      }else{
        window.open('https://t.me/kr_laile1');
      }
    }
  }
}
</script>
<style scoped>
.Menu-item {
  width: 38.5px;
  height: 38.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  border-radius: 10px;
  cursor: pointer;
}

.Menu-item-active {
  background-color: #020617;
}

.Menu-item-active span {
  color: #fff;
}

.Menu-item:hover {
  background-color: rgba(128, 128, 128, 0.1);
}

.Menu-item-active:hover {
  background-color: #020617c9;
}
</style>
